<template>
    <div class="view-report-page">
        <ViewGeneratorReportStaticHeaderContent
            :report-number="reportNumber"
            :report-type="reportTypeAsNumber"
            :generator-id="generatorId"
        />
        <div class="view-report-page__content">
            <ViewGeneratorReportActionsSection
                :generator-id="generatorId"
                :report-number="reportNumber"
                :report-type="reportTypeAsNumber"
                :component-type="ComponentType.Generator"
            />
            <MasterDataPanel
                v-if="generatorId"
                :generator-id="generatorId"
            />
            <ViewGeneratorReportMeasurementsSection
                v-if="generatorId"
                :report-number="reportNumber"
                :generator-id="generatorId"
            />
            <ViewGeneratorReportVisualInspectionSection
                v-if="reportTypeAsNumber === ReportType.GeneratorStatusReport && visualInspectionData"
                :id="AnalysisType.VisualInspection"
                :report-number="reportNumber"
                :visual-inspection-data="visualInspectionData"
                :status="data?.visualInspectionReport?.status"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import ViewGeneratorReportStaticHeaderContent from '@/pages/reports/view-report-page/generator/ViewGeneratorReportStaticHeaderContent.vue'
import { computed, toRefs, watch } from 'vue'
import ViewGeneratorReportActionsSection from '@/pages/reports/view-report-page/generator/sections/ViewGeneratorReportActionsSection.vue'
import MasterDataPanel from '@/pages/generators/condition-status/sections/master-data/MasterDataPanel.vue'
import ViewGeneratorReportMeasurementsSection from '@/pages/reports/view-report-page/generator/sections/ViewGeneratorReportMeasurementsSection.vue'
import { useGeneratorsReportDetailsExportStateStore } from '@/store/reports/export/generators/exportReportStateStore'
import { ComponentType } from '@/configuration/component/component-types'
import ViewGeneratorReportVisualInspectionSection from '@/pages/reports/view-report-page/generator/sections/ViewGeneratorReportVisualInspectionSection.vue'
import { ReportType } from '@/configuration/report/report-types'
import { useGeneratorReportGetQuery } from '@/api/queries/reports/useGeneratorReportGetQuery'
import { AnalysisType } from '@/configuration/analysis/analysis-types'

const props = defineProps<{
    generatorId: string
    reportNumber: string
    reportType: string
}>()

const { generatorId, reportNumber, reportType } = toRefs(props)
const reportTypeAsNumber = computed(() => Number(reportType.value))

const { data } = useGeneratorReportGetQuery(reportNumber, generatorId)
const generatorsReportDetailsExportStateStore = useGeneratorsReportDetailsExportStateStore()

const visualInspectionData = computed(() => {
    if (!data.value?.visualInspectionReport) {
        return undefined
    }

    return data.value.visualInspectionReport
})

watch(
    () => props.reportNumber,
    () => {
        generatorsReportDetailsExportStateStore.resetReportDetailsExportParameters()
    },
    { immediate: true },
)
</script>

<style scoped lang="scss">
.view-report-page {
    display: flex;
    flex-direction: column;

    max-height: calc(100vh - $navbar-height * 2);

    &__content {
        @include spacing-page;
        overflow-y: auto;

        display: flex;
        flex-direction: column;
        gap: $spacing-m;
    }
}
</style>
